import {combineReducers} from "redux";

import type {IFaq} from "@pg-mono/faq";
import {ILatestQueryAction, reduceLatestQuery, reduceResponse} from "@pg-mono/request-state";

import {fetchFaqTypes} from "../actions/fetch_faq";

export interface IFaqStore {
    data: IFaq[];
    latestQuery: Record<string, string>;
}

export const faqReducer = combineReducers({
    data: reduceResponse(fetchFaqTypes, [] as IFaq[]),
    latestQuery: reduceLatestQuery(fetchFaqTypes) as (state: Record<string, string> | undefined, action: ILatestQueryAction) => Record<string, string>
});
